<template>
    <div class="progress-circle-component" :style="{width: w + 'px', height: w + 'px'}" @mouseover="hover = true" @mouseleave="hover = false">
        <div class="progress-circle-border" :style="{border: isShowProgress ? strokeWidth + 'px solid ' + borderColor : 'none'}">
            <img :src="image.replace('/original', '/preview')" style="" alt="" v-if="image">
            <div class="progress-circle-percent" :style="{'color': percentColor, 'font-size': fontSize + 'px', 'background-color': hover ? convertHexToRGA(strokeColor, 0.4) : 'transparent'}" v-if="isShowProgress">
                <span v-if="showPercentAlways || hover">{{ percent > 100 ? 100 : percent }}<sub :style="{'font-size': fontSizePercent + 'px'}">%</sub></span>
            </div>
        </div>
        <svg width="100%" height="100%">
            <circle
                :stroke-width="strokeWidth * 2"
                :stroke="strokeColor"
                fill="transparent"
                :r="radius + 'px'"
                cx="50%" cy="50%"
                :stroke-dasharray="circumference + ' ' + circumference"
                :style="{'stroke-dashoffset': isShowProgress ? strokeDashoffset : 0}"></circle>
        </svg>
    </div>
</template>

<script>
export default {
    name: "ProgressCircle",
    data() {
        return {
            hover: false,
        }
    },
    props: {
        isShowProgress: {
            type: Boolean,
            default: true
        },
        showPercentAlways: { // Показывать ли процент всегда, а не только при наведении
            type: Boolean,
            default: false
        },
        borderColor: { // Цвет не заполненного бордера
            type: String,
            default: "#F2F2F2"
        },
        strokeColors: { // Цвета заполненного бордера, в зависимости от прогресса
            type: Object,
            default() {
                return {
                    0: "#EE7372",
                    40: "#F6C143",
                    80: "#2E76E4",
                };
            }
        },
        strokeWidth: { // Толщина бордера
            default: 3
        },
        percent: { // Процент прогресса
            default: 25
        },
        percentColor: { // Цвет шрифта процента
            default: '#ffffff'
        },
        w: { // Ширина и высота круга
            default: 42
        },
        fontSize: { // Размер шрифта процента
            default: 12
        },
        fontSizePercent: { // Размер шрифта значка %
            default: 8
        },
        image: { // Фоновая картинка, если надо
            type: String,
            default: ''
        }
    },
    computed: {
        strokeColor() {
            let strokeColor = "#EE7372";

            for (let percent in this.strokeColors) {
                if (this.percent >= percent) {
                    strokeColor = this.strokeColors[percent];
                }
            }

            return strokeColor;
        },
        radius() {
            return this.w / 2;
        },
        circumference() {
            return this.radius * 2 * Math.PI;
        },
        strokeDashoffset() {
            return this.circumference - (this.percent >= 100 ? 100 : this.percent) / 100 * this.circumference;
        }
    },
    methods: {
        convertHexToRGA(hexCode, opacity = 1) {
            let hex = hexCode.replace('#', '');

            if (hex.length === 3) {
                hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
            }

            const r = parseInt(hex.substring(0, 2), 16);
            const g = parseInt(hex.substring(2, 4), 16);
            const b = parseInt(hex.substring(4, 6), 16);

            /* Backward compatibility for whole number based opacity values. */
            if (opacity > 1 && opacity <= 100) {
                opacity = opacity / 100;
            }

            return `rgba(${r},${g},${b},${opacity})`;
        }
    }
}
</script>

<style lang="scss" scoped>
.progress-circle-component {
    position: relative;
    border-radius: 50%;
    overflow: hidden;
    cursor: pointer;

    .progress-circle-percent {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 2;
    }

    svg {
        transform: rotate(270deg);
    }

    .progress-circle-border {
        width: 100%;
        height: 100%;
        overflow: hidden;
        border-radius: 50%;
        position: absolute;

        img {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            height: 100%;
            width: 100%;
            object-fit: cover;

        }
    }
}
</style>
